import React, { useState, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import CustomCheckboxFilter from "../../../utils/CustomCheckboxFilter";
import CustomButton from "../../../utils/CustomButton";
import SearchFilter from "../../../utils/SearchFilter";
import { Spinner } from "@heroui/react";
ModuleRegistry.registerModules([AllCommunityModule]);

const ResultTable = ({ results, onDelete }) => {
  const [loading, setLoading] = useState(false);
  const [quickFilterText, setQuickFilterText] = useState("");
  const gridRef = useRef(null);
  const onGridReady = (params) => {
    gridRef.current = params.api;
  };

  const handleQuickFilterChange = (e) => {
    setQuickFilterText(e.target.value);
  };
  const columnDefs = [
    {
      headerName: "Sl.No",
      valueGetter: (params) => {
        const currentPage = params.api.paginationGetCurrentPage();
        const pageSize = params.api.paginationGetPageSize();
        const rowIndex = params.node.rowIndex;
        return currentPage * pageSize + rowIndex + 1;
      },
      maxWidth: 100,
    },
    {
      field: "marketname",
      headerName: "Market Name",
      sortable: true,
      filter: CustomCheckboxFilter,
    },
    {
      field: "matchname",
      headerName: "Match Name",
      sortable: true,
      filter: CustomCheckboxFilter,
    },
    {
      field: "matchdate",
      headerName: "Match Date",
      filter: CustomCheckboxFilter,
      sortable: true,
    },
    {
      field: "openresult",
      headerName: "Result",
      valueGetter: (params) => {
        const open = params.data.openresult || "";
        const close = params.data.closeresult || "";

        const isOnlyCommas = (str) => str.replace(/,/g, "").trim() === "";
        if (isOnlyCommas(open) && isOnlyCommas(close)) {
          return "---";
        }

        // Convert to arrays
        const openArr = open.split(",").filter(Boolean);
        const closeArr = close.split(",").filter(Boolean);

        // Extract key values
        const openDigit = openArr[0] || ""; // e.g., 6 or 9
        const openTriple = openArr[1] || ""; // e.g., 123 or 153
        const openLast = openArr[openArr.length - 1] || ""; // e.g., 64 or 94 (if exists)

        const closeTriple = closeArr[1] || ""; // e.g., 347
        const closeLast = closeArr[closeArr.length - 1] || "";

        // Build display pattern
        if (closeArr.length === 0) {
          return `${openTriple}-${openDigit}-***`;
        } else {
          return `${openTriple}-${openLast}-${closeTriple}`;
        }
      },
      // filter: CustomCheckboxFilter,
      sortable: false,
    },
    {
      headerName: "Actions",
      field: "actions", // optional
      cellRenderer: CustomButton,
      suppressMenu: true,
      sortable: false,
      filter: false,
    },
  ];
  const defaultColDef = {
    flex: 1,
    minWidth: 100,
    resizable: true,
  };

  if (loading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center">
        <img src="/img/Pinwheel.gif" alt="Loading..." className="w-16 h-16" />
      </div>
    );
  }

  return (
    <div className="shadow rounded-lg">
      {/* Search Input */}
      <div className="mb-4">
        <SearchFilter
          value={quickFilterText}
          onChange={handleQuickFilterChange}
        />
      </div>

      {/* AG Grid Table */}
      <div className="ag-theme-alpine" style={{ height: 750, width: "100%" }}>
        <AgGridReact
          rowData={results}
          quickFilterText={quickFilterText}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          enableCellTextSelection={true}
          pagination={true}
          paginationPageSize={20}
          onGridReady={onGridReady}
          context={{
            onDelete,
            viewMode: "result",
          }}
          overlayNoRowsTemplate="<span style='padding: 10px; display: block;'>No data found</span>"
          onFilterChanged={(params) => {
            const rowCount = params.api.getDisplayedRowCount();
            if (rowCount === 0) {
              params.api.showNoRowsOverlay();
            } else {
              params.api.hideOverlay();
            }
          }}
        />
      </div>
    </div>
  );
};

export default ResultTable;
